export const tr = {
    CLICKS: 'Tıklamalar',
    CPC: 'CPC',
    CPM: 'CPM',
    CTR: 'CTR',
    DEAL_TYPE: 'Tür',
    MIN_PRICE: '1000 gösterim için minimum fiyat',
    NAME: 'Ad',
    SHOWS: 'Gösterimler',
    SPENT: 'Harcamalar',
    STATUS: 'Durum',
    'without-nds': 'KDV hariç'
};
